import { Controller } from 'stimulus';
import controllerForElement from '../helpers/controllerForElement';

class PageBlocksController extends Controller {
  connect() {
    this.selectBox = this.element.querySelector('[data-controller="select"]');

    if (!this.selectBox) {
      return;
    }

    this.selectBox.addEventListener('change', this.onSelectChange.bind(this));
  }

  onSelectChange(event) {
    const { value } = event.detail;

    const targetElement = this.element.querySelector(`#${value}`);

    if (!targetElement) {
      return;
    }

    this.jumpToElement(targetElement, () => {
      targetElement.classList.add('is-highlighted');
    }, () => {
      targetElement.classList.remove('is-highlighted');
      this.resetSelectBox();
    });
  }

  async resetSelectBox() {
    const controller = await controllerForElement(this.selectBox, 'select');

    controller.reset();
  }

  // eslint-disable-next-line class-methods-use-this
  jumpToElement(element, onJumpComplete = null, onJumpCompleteDelayed = null, delay = 3000) {
    const elementTop = element.getBoundingClientRect().top + window.scrollY;

    window.scroll(0, elementTop - 30);

    onJumpComplete();

    setTimeout(() => {
      onJumpCompleteDelayed();
    }, delay);
  }
}

PageBlocksController.targets = [
  //
];

export default PageBlocksController;
